// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'animate.css'
import 'wowjs/css/libs/animate.css'
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
import 'element-ui/lib/theme-chalk/index.css';
import $ from 'jquery'


Vue.config.productionTip = false
Vue.use(ViewUI)

window.$ = $


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js